import { watch, toRef } from "vue";

export default function watchAndUpdate() {
  /**
   * Watches a value and updates a chosen Pinia store with the values
   * @param {object} form The form that's values are being watched.
   * @param {object} store The store that the state is to be bound to.
   * @param {function} callback OPTIONAL. Callback to run when complete.
   */
  const watchAndUpdateStore = (form, store, callback) => {
    Object.keys(form.value).forEach((key) => {
      watch(
        () => form.value[key],
        (val, oldVal) => {
          store.updateValue(key, val);
          if (callback) {
            callback(key, val);
          }
        },
        { immediate: true }
      );
    });
  };

  const watchFormAndUpdateStore = (form, store) => {
    watch(
      () => form.value,
      (formVal, oldVal) => {
        Object.keys(formVal).forEach((key) => {
          store.updateValue(key, formVal[key]);
        });
      },
      { deep: true }
    );
  };

  /**
   * Wrapper for vue watch and trigers a callback
   * @param {object} form The form that's values are being watched.
   * @param {object} store The store that the state is to be bound to.
   * @param {function} callback OPTIONAL. Callback to run when complete.
   */
  const watchAndTrigger = (
    watchObject,
    callback,
    options = {
      deep: false,
      immediate: false,
    }
  ) => {
    watch(
      () => toRef(watchObject),
      () => callback(),
      { deep: options.deep, immediate: options.immediate }
    );
  };

  return {
    watchAndTrigger,
    watchAndUpdateStore,
    watchFormAndUpdateStore,
  };
}
